import gql from 'graphql-tag';
import { get } from 'lodash';

import { useApolloClient, useQuery } from '@apollo/react-hooks';
import { Currency } from '@zapier/design-system-revenue/src/types';

const currencyFragment = gql`
  fragment currencyFragment on Currency {
    id
    icon
    multiplier
    name
    symbol
  }
`;

export const currencyQuery = gql`
  query currencyQuery {
    currencies {
      ...currencyFragment
    }

    selectedCurrency @client {
      ...currencyFragment
    }
  }

  ${currencyFragment}
`;

type Cache = {
  cache: {
    data: {
      selectedCurrency: {
        __typename: string;
        id: number;
        icon: string;
        multiplier: number;
        name: string;
        symbol: string;
      };
    };
  };
};

const resolvers = {
  Query: {
    selectedCurrency: (_: any, _args: any, { cache }: Cache) => {
      return (
        cache.data.selectedCurrency || {
          __typename: 'Currency',
          id: 'USD',
          icon: 'UnitedStates',
          multiplier: 1,
          name: 'USD',
          symbol: '$',
        }
      );
    },
  },
};

type UseCurrenciesOutput = {
  error: string | null;
  currencies: Currency[];
  onSelectCurrency: (currency: Currency) => any;
  selectedCurrency: Currency;
  isLoading: boolean;
};

export const useCurrencies = (): UseCurrenciesOutput => {
  const client = useApolloClient();
  client.addResolvers(resolvers);

  const queryResults = useQuery(currencyQuery);

  return {
    error: queryResults.error
      ? 'There was an issue loading currencies. Please try again'
      : null,
    currencies: get(queryResults, ['data', 'currencies']) || [],
    onSelectCurrency: (currency: Currency) =>
      queryResults.client.writeData({
        data: { selectedCurrency: currency },
      }),
    selectedCurrency: get(queryResults, ['data', 'selectedCurrency']),
    isLoading: queryResults.loading,
  };
};
